// @flow
import * as React from 'react';
import { FieldWrapper } from 'speed-js-react-web';
import { FormattedMessage } from 'react-intl';
import { Text, TextInput } from 'grommet';


type Props = {
    calculateMaxRange: Function,
    value: ?number,
    onChange: Function,
    error: ?boolean,
    onError: Function,
};

const RangeSelect = (props: Props) => {
    const {
        calculateMaxRange, value, onChange, error, onError,
    } = props;

    const maxRange = calculateMaxRange();

    return (
        <FieldWrapper
            key="range-field"
            label={(
                <FormattedMessage
                    id="range-title"
                    defaultMessage="Range"
                    values={{ first: 1, second: maxRange }}
                />
            )}
            required
        >
            <TextInput
                name="range-input"
                type="number"
                disabled={maxRange <= 1}
                onChange={(e) => {
                    const choice = Number(e.target.value);
                    onChange(choice);
                    if (!choice || (choice && (choice > maxRange || choice < 0))) {
                        onError(true);
                    } else {
                        onError(false);
                    }
                }}
                min={1}
                max={maxRange}
                value={value || ''}
            />
            {error && (
                <Text
                    color="status-error"
                    alignSelf="center"
                    margin={{ top: '10px' }}
                >
                    <FormattedMessage
                        id="error-range"
                        defaultMessage="The chosen value must be between {first} and {maxRange}."
                        values={{ first: 1, maxRange }}
                    />
                </Text>
            )}
        </FieldWrapper>
    );
};

export default RangeSelect;
